import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { environment as env } from '../../../../environments/environment';
import { Package } from '../../../models/package.model';
import { Product } from '../../../models/product.model';
import { CodesApiService } from '../../../services/codes-api.service';

export interface PackageDialogInputData {
  product$: Observable<Product>;
  package: Package;
  internalUser: boolean;
  currency: string;
  cart: boolean;
}

export interface PackageDialogReturnData {
  package: Package;
  deselect: boolean;
  orderCertificateCode: string;
  orderCertificateName: string;
  orderPrice: number;
}

@Component({
  selector: 'app-package-dialog',
  templateUrl: './package-dialog.component.html',
  styleUrls: ['./package-dialog.component.scss'],
  providers: [DatePipe],
})
export class PackageDialogComponent implements OnInit {

  pkg: Package;

  minPrice = env.minPrice || 50;
  maxPrice = env.maxPrice || 2000;

  constructor(
    @Inject(MAT_DIALOG_DATA) public input: PackageDialogInputData,
    private dialogRef: MatDialogRef<PackageDialogComponent>,
    public codesApiService: CodesApiService,
  ) {
    this.pkg = Object.assign({}, this.input.package);
  }

  ngOnInit() {
  }

  deselect(): void {
    this.dialogRef.close({ package: this.input.package, deselect: true } as Partial<PackageDialogReturnData>);
  }

  close(): void {
    this.dialogRef.close({ package: this.input.package } as Partial<PackageDialogReturnData>);
  }

  save(): void {
    return this.dialogRef.close(
      {
        package: this.pkg,
      } as Partial<PackageDialogReturnData>
    );
  }

  validPrice(price: number) {
    return price >= this.minPrice && price <= this.maxPrice;
  }
}
